import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { AlertOctagon, RotateCcw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { StatusScreen } from '@/components/ui/status-screen';

export const GlobalErrorPage: React.FC = () => {
    const error: any = useRouteError();
    const navigate = useNavigate();

    return (
        <StatusScreen
            icon={AlertOctagon}
            tone="danger"
            code="Unexpected error"
            title="Something went wrong"
            description="We hit a problem loading this page. Try again — if it keeps happening, share the details below with your system administrator."
            actions={
                <>
                    <Button onClick={() => window.location.reload()}>
                        <RotateCcw />
                        Try again
                    </Button>
                    <Button variant="outline" onClick={() => navigate('/dashboard')}>
                        <Home />
                        Back to overview
                    </Button>
                </>
            }
        >
            <details className="rounded-lg border bg-card p-4 text-left shadow-card">
                <summary className="cursor-pointer text-body-sm font-semibold text-foreground">Technical details</summary>
                <p className="mt-3 break-all font-mono text-caption text-danger">
                    {error?.statusText || error?.message || 'Unknown error'}
                </p>
            </details>
        </StatusScreen>
    );
};
